export default __webpack_public_path__ + "static/media/buffering2.37f6db45.svg";